import { Component, Inject, Input, OnInit } from '@angular/core';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ClipboardService } from 'ngx-clipboard';

@Component({
    selector: 'app-cloud-resources-inventory',
    templateUrl: './cloud-resources-inventory.component.html',
    styleUrls: ['./cloud-resources-inventory.component.scss'],
    standalone: false
})
export class CloudResourcesInventoryComponent implements OnInit {
  copy: boolean;
  @Input() inventoryData: any;
  @Input() copyInventoryData: boolean;
  @Input() instanceName: any
  formattedLines: string[] = [];
  maxCount = 1;
  isAsc = true;
  cloudResourceType: any;

  constructor(public sidenavService: SidenavService, private clipboardApi: ClipboardService,) { }
  typeCountList: { type: string; count: number }[] = [];
  typeCountList1: { type: string; count: number }[] = [];
  typeCountList2: { type: string; count: number }[] = [];


  ngOnInit(): void {
    const jsonString = JSON.stringify(this.inventoryData, null, 2);
    this.formattedLines = jsonString.split('\n');
    this.copy = false;
   if(this.copyInventoryData){
   this.cloudResourceType = this.inventoryData?.type?.split("/")[1];
   }

    //ViewType inventoryData processing
    if (this.inventoryData?.length) {
      const typeMap: { [key: string]: number } = {};

      this.inventoryData.forEach((item: any) => {
        let type = item.type;
        if (type && type.includes('/')) {
          type = type.split('/')[1];
          typeMap[type] = (typeMap[type] || 0) + 1;
        }
      });

      this.typeCountList = Object.entries(typeMap).map(([type, count]) => ({ type, count }));
      this.maxCount = Math.max(...this.typeCountList.map(t => t.count));

      if (this.typeCountList?.length > 17) {
        this.typeCountList1 = this.typeCountList.slice(0, 17);
        this.typeCountList2 = this.typeCountList.slice(17);
      }
      if (this.typeCountList?.length > 34) {
        const middleIndex = Math.ceil(this.typeCountList.length / 2);
        this.typeCountList1 = this.typeCountList.slice(0, middleIndex);
        this.typeCountList2 = this.typeCountList.slice(middleIndex);
      }

    }
  }


  copyText(): void {
    const copyJson = this.formattedLines.join('\n');
    this.copy = true;
    this.clipboardApi.copyFromContent(copyJson);
    setTimeout(() => {
      this.copy = false;
    }, 5000);
  }

  sortInventoryCloud() {
    this.typeCountList.sort((a, b) =>
      this.isAsc
        ? a.type.localeCompare(b.type)
        : b.type.localeCompare(a.type)
    );
    this.isAsc = !this.isAsc;
    if (this.typeCountList?.length > 17) {
      this.typeCountList1 = this.typeCountList.slice(0, 17);
      this.typeCountList2 = this.typeCountList.slice(17);
    }
    if (this.typeCountList?.length > 34) {
      const middleIndex = Math.ceil(this.typeCountList.length / 2);
      this.typeCountList1 = this.typeCountList.slice(0, middleIndex);
      this.typeCountList2 = this.typeCountList.slice(middleIndex);
    }
  }

}



